// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jObW","field":"styles_field__2W6ny","fieldCol":"styles_fieldCol__HwYWT","diffCol":"styles_diffCol__PqsY1","diff":"styles_diff__1a1Gu"};